// removed by extract-text-webpack-plugin
module.exports = {"page":"styles-_vars__page__29HLL","code-example":"styles-_vars__code-example__38enP","codeExample":"styles-_vars__code-example__38enP","screenshot":"styles-_vars__screenshot__1t8HT"};


//////////////////
// WEBPACK FOOTER
// ./styles/_vars.scss
// module id = 88
// module chunks = 0